/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { getRemoteConfig } from 'firebase/remote-config';
import { fetchAndActivate } from 'firebase/remote-config';
import { initializeApp } from 'firebase/app';
import { getValue } from 'firebase/remote-config';
import { getCurrentDomainName } from '../lib/utils';

const useCognito = () => {
  // Import the functions you need from the SDKs you need
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
  const [cognitoLoginLink, setCognitoLogin] = useState<string>();
  const [cognitoSignUpLink, setCognitoSignUp] = useState<string>();
  const [requestApiUrl, setRequestApiUrl] = useState<string>();
  const [CMSUrl, setCMSUrl] = useState<string>();
  const [CMSToken, setCMSToken] = useState<string>();
  const [companyFeatureName, setCompanyFeatureName] = useState<string>('');
  const [articlesFeatureName, setArticlesFeatureName] = useState<string>('');
  // const [companyFeatureName, setCompanyFeatureName] = useState<string>('Press Release, Announcement');
  // const [articlesFeatureName, setArticlesFeatureName] = useState<string>('News Article');
  const [hostNewFeatureName, setHostNewFeatureName] = useState<string>('');
  const [blogsFeatureName, setBlogsFeatureName] = useState<string>('');

  const [cognitoConfig, setCognitoConfig] = useState<any>({
    region: '',
    userPool: '',
    userPoolBaseUri: '',
    clientId: '',
    callbackUri: `${getCurrentDomainName()}/logincallback`,
    signoutUri: `${getCurrentDomainName()}/logoutcallback`,
    tokenScopes: ['openid', 'email', 'profile'],
    apiUri: '',
  });

  useEffect(() => {
    fetchAndActivate(remoteConfig)
      .then(() => {
        const appClientId: any = getValue(remoteConfig, 'COGNITO_APP_CLIENT_ID');
        const userPoolId: any = getValue(remoteConfig, 'COGNITO_USER_POOL_ID');
        const hostDomainUrl: any = getValue(remoteConfig, 'COGNITO_HOSTED_DOMAIN_URL');
        const region: any = getValue(remoteConfig, 'COGNITO_REGION');
        const requestApiUrl: any = getValue(remoteConfig, 'REQUEST_API_URL');

        // remote config dms
        const cmsUrl: any = getValue(remoteConfig, 'CMS_REQUEST_URL');
        const cmsToken: any = getValue(remoteConfig, 'CMS_REQUEST_TOKEN');
        const hostNewKey: any = getValue(remoteConfig, 'HOST_NEW_FEATURE_NAME');
        const companyFeatureKey: any = getValue(remoteConfig, 'COMPANY_NEWS_FEATURE_NAME');
        const articlesFeatureKey: any = getValue(remoteConfig, 'ARTICLES_NEWS_FEATURE_NAME');
        const blogsFeatureKey: any = getValue(remoteConfig, 'BLOGS_FEATURE_NAME');

        setRequestApiUrl(requestApiUrl._value);
        setCMSUrl(cmsUrl._value);
        setCMSToken(cmsToken._value);
        setCompanyFeatureName(companyFeatureKey._value);
        setArticlesFeatureName(articlesFeatureKey._value);
        setHostNewFeatureName(hostNewKey._value);
        setBlogsFeatureName(blogsFeatureKey._value);

        setCognitoConfig((prevState: any) => ({
          ...prevState,
          client_id: appClientId._value,
          userPool: userPoolId._value,
          userPoolBaseUri: hostDomainUrl._value,
          apiUri: hostDomainUrl._value,
          region: region._value,
        }));
        setCognitoLogin(
          `${hostDomainUrl._value}/login?response_type=code&client_id=${
            appClientId._value
          }&redirect_uri=${getCurrentDomainName()}/logincallback`,
        );

        setCognitoSignUp(
          `${hostDomainUrl._value}/signup?response_type=code&client_id=${
            appClientId._value
          }&redirect_uri=${getCurrentDomainName()}/logincallback`,
        );

        const configCognitoData = {
          region: region._value,
          userPool: userPoolId._value,
          userPoolBaseUri: hostDomainUrl._value,
          clientId: appClientId._value,
          callbackUri: `${getCurrentDomainName()}/logincallback`,
          signoutUri: `${getCurrentDomainName()}/logoutcallback`,
          tokenScopes: ['openid', 'email', 'profile'],
          apiUri: hostDomainUrl._value,
        };

        localStorage.setItem('cognito-config', JSON.stringify(configCognitoData));
      })
      .catch((err) => {
        // ...
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    cognitoLoginLink,
    cognitoConfig,
    cognitoSignUpLink,
    requestApiUrl,
    CMSUrl,
    CMSToken,
    hostNewFeatureName,
    companyFeatureName,
    articlesFeatureName,
    blogsFeatureName
  };
};

export default useCognito;
